<template>
	<v-dialog
		v-model="fileMetaEditorDialog"
		fullscreen
		scrollable
		hide-overlay
		transition="dialog-bottom-transition"
		persistent
	>
		<!-- @keydown.esc="logEsc($event)" -->
		<v-card>
			<v-toolbar>
				<v-btn icon @click="closeFileMetaDialog">
					<v-icon>close</v-icon>
				</v-btn>
				<v-toolbar-title>
					{{ selectedFile.stockistName }} -
					{{ selectedFile.filename }}
				</v-toolbar-title>
				<template v-slot:extension>
					<v-tabs v-model="model" slider-color="yellow" align-with-title grow>
						<v-tab v-for="i in tabItems" :key="i.tabId" :href="`#${i.tabId}`">{{
							i.name
						}}</v-tab>
					</v-tabs>
				</template>
			</v-toolbar>
			<v-tabs-items v-model="model">
				<v-tab-item v-for="i in tabItems" :key="i.tabId" :value="i.tabId">
					<v-card flat>
						<v-card-text>
							<component :dataProp="i.props" v-bind:is="i.component" />
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</v-card>
	</v-dialog>
</template>

<script>
import FileViewer from './fileViewer';
import FileMetaEditor from './fileMetaEditor';
import JSONViewer from './jsonViewer';
import ExtractedOutputViewer from './extractedOutputViewer';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
export default {
	components: {
		FileViewer,
		FileMetaEditor,
		JSONViewer,
		ExtractedOutputViewer,
	},
	data() {
		return {
			tabItems: [
				/*  
					                        json viewer is a component jo brace mai json bata deta hai parsed and extracted
					                        ka similar one has to be made for the selected file meta and the extracted data
						                */

				{
					name: 'Current File',
					tabId: 'tab-1',
					component: 'FileViewer',
					props: {},
				},
				{
					name: 'Detected File Meta',
					tabId: 'tab-2',
					component: 'FileMetaEditor', // this component should show the detected meta for the file and it needs to be more like json viewer and not a editor
					props: {},
				},
				// {
				// 	name: "Parsed",
				// 	tabId: "tab-3",
				// 	component: "JSONViewer",
				// 	props: {
				// 		renderMode: "parsed"
				// 	}
				// },
				{
					name: 'Transformed',
					tabId: 'tab-4',
					component: 'JSONViewer',
					props: {
						renderMode: 'transformed',
					},
				},
				{
					name: 'Extracted Data',
					tabId: 'tab-5',
					component: 'ExtractedOutputViewer', // add a json viewer here and show some extracted lines from this file like 40-50
					props: {},
				},
			],
			model: 'tab-1',
		};
	},
	methods: {
		...mapMutations('extractedData', ['closeFileMetaDialog']),
		logEsc(e) {
			// console.log("ESC Pressed");
			e.preventDefault();
		},
	},
	computed: {
		...mapGetters('extractedData', ['fileMetaEditorDialog', 'selectedFile']),
	},
};
</script>

<style lang="scss" scoped>
.v-card__text {
	padding: 0px;
}
</style>
